import { OptionsSendCodeEnum } from "enums/OptionsSendCodeEnum"

export const SendCodeOptions: Array<object> = [
  {
    value: OptionsSendCodeEnum.sms,
    label: "SMS",
    portabilidad: "SI"
  },
  {
    value: OptionsSendCodeEnum.email,
    label: "E-Mail",
    portabilidad: "NO"
  },
  {
    value: OptionsSendCodeEnum.sms,
    label: "SMS",
    portabilidad: "NO"
  },
]